interface IQuickSummarySection {
  title: string | JSX.Element | undefined;
  content: string | JSX.Element | undefined;
}

export const QuickSummarySection = ({
  title,
  content,
}: IQuickSummarySection) => {
  return (
    <div className="py-8 px-12 sm:py-6 sm:px-6">
      <div className={`flex items-center gap-4 w-full mb-6 sm:gap-3 sm:mb-2`}>
        <img
          src="https://assets.clear.in/cleartax/images/1716884396_pancardlink.svg"
          width={32}
          height={32}
          alt=""
        />
        <div className="text-s-20 font-medium sm:text-s-14 sm:font-semibold">
          {title}
        </div>
      </div>
      <p className="[&>*]:text-grey-700 [&>*]:text-base sm:[&>*]:text-s-12 sm:pl-12">
        {content}
      </p>
    </div>
  );
};
